<template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
        <div class="listtitle">车船基本信息管理</div>
        <el-form
          class="zj-search-form"
          ref="form"
          :model="form"
          :label-width="labelWidth"
        >
          <el-form-item label="车船名称" prop="CarName">
            <el-input v-model="CarName" placeholder="请输入名称"></el-input>
          </el-form-item>
          <el-form-item label="车船类型">
            <el-select v-model="DeviceType" placeholder="请选择">
              <!-- <el-option key label="全部" value="null"></el-option> -->
              <el-option
                v-for="item in carTypeData"
                :key="item.dictValue"
                :label="item.dictName"
                :value="item.dictValue"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-button-bar">
          <el-button size="mini" @click="onAdd">添 加</el-button>
        </div>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table
              :data="tableData"
              ref="multipleTable"
              border
              style="width: 100%"
              fixed
            >
              <el-table-column
                type="index"
                label="序号"
                width="80"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="carName"
                label="车船名称"
              ></el-table-column>
              <el-table-column prop="carNo" label="车船编号"></el-table-column>
              <el-table-column prop="carType" label="车船类型">
                <template slot-scope="scope">
                  <span v-if="scope.row.carType == '1'">车辆</span>
                  <span v-else-if="scope.row.carType == '2'">游船</span>
                </template>
              </el-table-column>
              <el-table-column prop="plateNo" label="车牌号"></el-table-column>
              <el-table-column prop="simNo" label="SIM卡号"></el-table-column>
              <el-table-column
                prop="contactsPerson"
                label="负责人"
              ></el-table-column>
              <el-table-column label="操作" width="120" align="center">
                <template slot-scope="scope">
                  <template>
                    <el-button
                      @click="queryDetail(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >查看</el-button
                    >
                    <el-button
                      @click="editDetail(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >编辑</el-button
                    >
                    <el-button
                      @click="deleteClick(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >删除</el-button
                    >
                  </template>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
  </div>
</template>

<script>
import { listCarShip, delCarShip } from "@/api/src/carship";
export default {
  name: "CarShipManagerView",
  controller: "UI",
  action: "CarShipManagerView",
  dicts: ["car_type"],
  data() {
    return {
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      CarName: null,
      DeviceType: null,
      carTypeData:[]
    };
  },
  created(){
    this.getdictions();
  },
  mounted: function () {
    this.search();
    this.logInfo.ActionName = "车船基本信息查询";
    this.logInfo.LogMessage = "车船基本信息查询";
    this.logInfo.ModuleName = "车辆调度";
    this.logInfo.PageName = "车船基本信息列表";
    this.addOperationLog();
  },
  methods: {
    getdictions(){
      this.$nextTick(() => {
        this.getDicts("car_type").then((res) => {
          console.log("res")
          console.log(res)
          this.carTypeData = res.rows;
        });
      });
    },
    search() {
      let searchInfo = {
        carName: this.CarName,
        carType: this.DeviceType,
        pageSize: this.pageSize,
        pageNum: this.currentPage,
      };
      listCarShip(searchInfo).then((r) => {
        this.tableData = r.rows;
        this.total = r.total;
      });
    },
    //添加
    onAdd() {
      this.$router.push({
        path: "/plugin/vehicleScheduling/UI/CarShipManagerInfo",
        query: {
          type: "add",
        },
      });
    },
    //查看
    queryDetail(index, row) {
      this.$router.push({
        path: "/plugin/vehicleScheduling/ui/CarShipManagerInfo",
        query: { InfoId: row.id, type: "query" },
      });
    },
    //编辑
    editDetail(index, row) {
      this.$router.push({
        path: "/plugin/vehicleScheduling/ui/CarShipManagerInfo",
        query: { InfoId: row.id, type: "edit" },
      });
    },
    //行删除
    deleteClick(index, row) {
      this.$confirm("此操作将永久删除该行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delCarShip(row.id)
            .then((r) => {
              let success = r.code == 200;
              if (success) {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
                this.logInfo.ActionName = "车船基本信息删除";
                this.logInfo.LogMessage = "车船基本信息删除";
                this.logInfo.ModuleName = "车辆调度";
                this.logInfo.PageName = "车船基本信息列表";
                this.addOperationLog();
              } else {
                this.$message({
                  type: "error",
                  message: "删除失败!",
                });
              }
              this.search();
            })
            .catch((e) => {
              console.log(e);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 点击查询按钮
    onSearch() {
      this.currentPage = 1;
      this.search();
    },
    clearsearch() {
      this.CarName = null;
      this.DeviceType = null;
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
      this.search();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
  },
};
</script>
